import theme from '../base'

const typography = {
  MuiTypography: {
    styleOverrides: {
      root: {
        '&.mainTitle': {
          color: theme.palette.neutral.black,
        },
        '&.secondaryTitle': {
          color: theme.palette.neutral.dark,
          '& span': {
            marginLeft: theme.spacing(1),
            color: theme.palette.neutral.main,
          },
        },
        '&.decorator': {
          position: 'relative',
          '&:after': {
            content: '""',
            width: theme.spacing(2),
            position: 'absolute',
            display: 'block',
            borderBottom: `3px solid ${theme.palette.primary.main}`,
          },
        },
      },
    },
  },
}

export default typography
